import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Certificate } from '@shared/models';

@Component({
  selector: 'mojo-candidate-certifications-card',
  templateUrl: './candidate-certifications-card.component.html',
  styleUrls: ['./candidate-certifications-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateCertificationsCardComponent {
  private readonly maxCertificationsNumber = 3;
  @Input() showCard = true;
  @Input()
  set certifications(certifications: Certificate[]) {
    this.allCertifications = certifications;
    this.expandable = this.allCertifications.length > this.maxCertificationsNumber;
    this.prepareDisplayedCertification();
  }

  displayedCertifications: Certificate[];
  allCertifications: Certificate[];
  expandable = false;
  expanded = false;

  track = (index: number, item: Certificate) => item.name;

  toggleCard(expanded: boolean) {
    this.expanded = expanded;
    this.prepareDisplayedCertification();
  }

  private prepareDisplayedCertification() {
    if (this.expanded) {
      this.displayedCertifications = this.allCertifications;
    } else {
      this.displayedCertifications = this.allCertifications.slice(0, this.maxCertificationsNumber);
    }
  }
}
